import * as React from 'react';
import { Widget } from './Widget';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsModal, selectWidgetMode, selectWidgetStatus } from '../../../selectors/layout';
import { getTitle } from './utils';
import { ModalWindow } from '@cian/ui-kit';
import { closeModalThunk } from '../../../thunks/closeModal';
import { TThunkDispatch } from '../../../types/redux';
import { EWidgetStatus } from '../../../types/redux/layout';
import { Preloader } from '../Preloader';
import { WrapperContainer } from './components/Wrapper';

export const WidgetContainer = () => {
  const isModal = useSelector(selectIsModal);
  const mode = useSelector(selectWidgetMode);
  const status = useSelector(selectWidgetStatus);

  const title = getTitle(mode);
  const isInitial = status === EWidgetStatus.Initial;

  const dispatch = useDispatch<TThunkDispatch>();

  const handleClose = React.useCallback(() => {
    dispatch(closeModalThunk());
  }, [dispatch]);

  const content = isInitial ? <Preloader /> : <Widget />;

  if (isModal) {
    return (
      <ModalWindow open title={title} maxWidth={492} width={'100%'} onClose={handleClose}>
        <WrapperContainer>{content}</WrapperContainer>
      </ModalWindow>
    );
  }

  return <WrapperContainer>{content}</WrapperContainer>;
};
